import {Injectable} from '@angular/core';
import { Subject } from 'rxjs';
import {SiteHoldingPen} from '../domain/auction-event';

@Injectable({
  providedIn: 'root'
})
export abstract class ItemSummarySiteAuctionEventService {

  siteHoldingPenCallback: Subject<SiteHoldingPen> = new Subject<SiteHoldingPen>();

  abstract getSiteHoldingPen(siteId: number): void;
}
